const whitelabelConfig = {
  'bionic': {
    'firstQuestionSlug': '/question/voip-user',
    'scssVariables': './src/assets/scss/_bionic_variables.scss',
    'name': 'Bionic',
    'logo': 'bionic-logo-dark.svg',
    'mobileLogo': 'bionic-logo-dark.svg',
    'addressItemIcon': 'caret-right-circle.svg',
    'callIcon': 'orange-tilt-phone.svg',
    'searchButtonIcon': 'magnifying-glass-white.svg',
    'searchButtonIconHover': 'magnifying-glass-white.svg',
    'buttonIcon': 'bionic-arrow-white.svg',
    'inputSuccessIcon': 'check-circle-green.svg',
    'inputErrorIcon': 'error-circle.svg',
    'useInputLeftIcons': false,
    'serviceIcons': {
      voip: 'use-voip.svg',
      voipSelected: 'use-voip.svg',
      noVoip: 'no-voip.svg',
      noVoipSelected: 'no-voip.svg'
    },
    'supplierUseWhiteLogos': false,
    'supplierCheckboxImage': 'white-tick.svg',
    'showRadioCheckIcon': true,
    'tooltipCharacter': '?',
    'useResultsPageImages': true,
    'resultsPageCheckIcon': 'check-circle-purple.svg',
    'cookieWall': false,
    'useChatPageImages': true,
    'callNowText': 'Talk through your comparison',
    'scheduleCallText': 'Talk through your comparison',
    'chatPageDisclaimer': 'You can find full details of how your data will be used by Bionic in our <strong><a href="https://bionic.co.uk/about-bionic/privacy/" target="_blank">Privacy Policy</a></strong>. By pressing "Talk through your comparison", you confirm you agree to have read and understood our <strong><a href="https://bionic.co.uk/about-bionic/terms-and-conditions/" target="_blank">website Terms and Conditions.</a> ',
    'chatPageDisclaimerLinkIcon': '',
    'useConfirmationLogo': true,
    'confirmationPageImage': 'call-schedule.png',
    'hideNavOnConfirmationAndError': false,
    'utag': false,
    'energyLink': 'https://bionic.co.uk/business-energy',
    'insuranceLink': 'https://bionic.co.uk/business-insurance',
    'telcoLink': 'https://bionic.co.uk/business-connectivity',
    'homeLink': 'https://bionic.co.uk/',
    'contactFormBusinessNameText': 'e.g. Bionic',
    'contactFormFullNameText': 'e.g. John Smith',
    'contactFormPhoneText': 'e.g. 02000000000',
    'contactFormEmailText': 'e.g. name@domain.com',
    'appTitle': 'Bionic - Phone & Broadband',
    'useLocationPinIcon': false,
    'postcodeSuccessIcon': 'check-circle-orange.svg',
    'useAddressItemIcon': false,
    'prependSearchIcon': true,
    'placeholderText': 'Search for your address...',
    'navPhoneIcon': 'orange-phone.svg',
    'cdcTitle': 'Let us know the best way to talk you through your comparison',
    'cdcSubtitle': 'Your expert will prepare free quotes for cloud phone systems based on your needs and preferences'
  },
  'ctm': {
    'firstQuestionSlug': '/question/postcode',
    'scssVariables': './src/assets/scss/_ctm_variables.scss',
    'name': 'Compare the Market',
    'logo': 'compareTheMarketLogo.svg',
    'mobileLogo': 'compareTheMarketMobileLogo.svg',
    'addressItemIcon': 'CTASearchArrow.svg',
    'callIcon': 'ctm-call-circle.svg',
    'searchButtonIcon': 'magnifying-glass-white.svg',
    'searchButtonIconHover': 'magnifying-glass-white.svg',
    'buttonIcon': 'ctm-arrow-white.svg',
    'inputSuccessIcon': 'ctm-success.png',
    'inputErrorIcon': 'ctm-error.svg',
    'useInputLeftIcons': false,
    'serviceIcons': {
      voip: 'use-voip.svg',
      voipSelected: 'use-voip.svg',
      noVoip: 'no-voip.svg',
      noVoipSelected: 'no-voip.svg'
    },
    'supplierUseWhiteLogos': true,
    'supplierCheckboxImage': 'white-tick.svg',
    'showRadioCheckIcon': false,
    'tooltipCharacter': 'i',
    'useResultsPageImages': false,
    'resultsPageCheckIcon': 'ctm-check-circle.svg',
    'cookieWall': true,
    'useChatPageImages': false,
    'callNowText': 'Call me now',
    'scheduleCallText': 'Schedule Call',
    'chatPageDisclaimer': 'You can find full details of how your data will be used by <a href="https://www.comparethemarket.com/" class="chat-form-disclaimer__link" target="_blank"><strong>compare</strong>the<strong>market</strong>.com</a> and Bionic in our <a href="https://www.comparethemarket.com/information/privacy-policy/" class="chat-form-disclaimer__link" target="_blank">Privacy Policy</a>. If you are providing information about someone else you must inform them of our <a href="https://www.comparethemarket.com/information/privacy-policy/" class="chat-form-disclaimer__link" target="_blank">Privacy Policy</a>. By continuing, you confirm you have read and understood our website <a href="https://www.comparethemarket.com/information/terms-and-conditions/" class="chat-form-disclaimer__link" target="_blank">Terms and Conditions</a>, any queries in relation to these please <a href="https://help.comparethemarket.com/" class="chat-form-disclaimer__link" target="_blank">Contact Us.</a>',
    'chatPageDisclaimerLinkIcon': 'ctm-new-tab-icon.svg',
    'useConfirmationLogo': false,
    'confirmationPageImage': 'ctm-call-schedule.png',
    'hideNavOnConfirmationAndError': false,
    'utag': true,
    'energyLink': 'https://www.comparethemarket.com/energy/business',
    'insuranceLink': 'https://www.comparethemarket.com/business-insurance',
    'telcoLink': 'https://www.comparethemarket.com/broadband/business-broadband',
    'homeLink': 'https://www.comparethemarket.com',
    'contactFormBusinessNameText': 'Tell us your business name',
    'contactFormFullNameText': 'First and last name',
    'contactFormPhoneText': 'Tell us a landline or mobile number...',
    'contactFormEmailText': 'Enter a valid email address',
    'appTitle': 'Compare the Market - Phone & Broadband',
    'useLocationPinIcon': true,
    'postcodeSuccessIcon': null,
    'useAddressItemIcon': true,
    'prependSearchIcon': false,
    'placeholderText': 'Search...',
    'navPhoneIcon': 'call-light.svg',
    'cdcTitle': 'Perfect! We’ll prepare your quotes and an expert will talk you through them.',
    'cdcSubtitle': "What we'll consider when tailoring your package:"
  }
}

module.exports = whitelabelConfig
